import React from 'react';
import PropTypes from 'prop-types';
import DatePickerHOC from 'components/widgets/datePickerController';
import momentPropTypes from 'react-moment-proptypes';
import { propTypes } from 'react-bootstrap/esm/Image';
import NumberFormat from 'react-number-format';
import Lang from 'libraries/Lang';

const CustomDatePicker = (props) => {
    const {
        date,
        label,
        dateId,
        datePlaceholderText,
        showCalendar,
        dateChanged,
        onDatesChange,
        customDateChanged,
        depDate,
        isStartDateValid,
        CustomDatePicker,
        activeTab,
        dateFormat,
        validateDate,
        onFocus,
    } = props;

    return (
        <div className="d-flex">

            <div className="date-picker-btn position-relative col text-left col">
                {/* <button className="date-picker-btn col text-left" type="button" id={dateId} onClick={(e) => { showCalendar(e); }}>
                    <span className="text-label">{label}</span>
                    {(date && date.format('MM/DD/YYYY')) || datePlaceholderText}
                </button> */}

                <span className="text-label">{label}</span>
                <label onClick={(e) => {
                    onFocus('date'); showCalendar(e);
                }}
                >   <svg className="icon right mt-3" title="">
                        <use xmlnsXlink="http://www.w3.org/2000/svg" xlinkHref="/img/icons/icon-defs.svg#icon-calendar" />
                    </svg>
                </label>
                <input
                    //  mask="_"
                    // format="##/##/####"
                    className="w-100 h-100 py-0 pl-0 pb-1 pr-3"
                    // placeholder={startDatePlaceholderText}
                    value={(date && isStartDateValid && date.format(dateFormat)) || date}
                    name="depDate"
                    placeholder={datePlaceholderText}
                    autoComplete="off"
                    onChange={(e) => { customDateChanged(e); }}
                    onBlur={(e) => { validateDate(e); }}
                />

            </div>
        </div>
    );
};

CustomDatePicker.propTypes = {
    // date: momentPropTypes.momentObj,
    datePlaceholderText: PropTypes.string,
    dateId: PropTypes.string.isRequired,
    label: PropTypes.string,
    showCalendar: PropTypes.func.isRequired,
    onDatesChange: propTypes.func,
    dateChanged: PropTypes.func.isRequired,
    customDateChanged: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
};

CustomDatePicker.defaultProps = {
    date: null,
    label: 'Depart',
    datePlaceholderText: 'Select Date',
};

export default DatePickerHOC(CustomDatePicker);
